











































































import {Component, Prop} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay} from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import { ErrorParseMethodEnum } from '@/services/models/Enums';
import UserApi from '@/services/rest/bemob/user';


@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons,
    ErrorAggregator
  }
})
export default class ChangePwdDialog extends Form {
  @Prop()
  userApi: UserApi = new UserApi();

  edit: boolean = true;
  show_password: boolean = false;

  form: any = {};
  errors: any[] = [];
  errorsControlActive: boolean = false;

  get formDisabled() {
    return !this.form.confirmPassword || !this.form.password || !this.form.oldPassword;
  }


  getError(input: string):  any[] {
    let errors = this.pGetError(input);
    return errors
      ? errors.map((error: any) => this.t(error))
      : [];
  }

  close() {
    this.$emit('close');
  }

  @Send(true)
  submit() {
    this.errors=[];
    this.errorsControlActive = false;

    if(!this.form.oldPassword){
      const errorText = this.t('{0} is required',[this.t('Old password')])
      this.state['oldPassword:error'] = errorText
      this.errors.push(errorText)
    }

    if(!this.form.password){
      const errorText = this.t('{0} is required',[this.t('New password')])
      this.state['password:error'] = errorText
      this.errors.push(errorText)
    }

    if(!this.form.confirmPassword){
      const errorText = this.t('{0} is required',[this.t('Repeat Password')])
      this.state['confirmPassword:error'] = errorText;
      this.errors.push(errorText)
    }

    if(this.form.password !== this.form.confirmPassword) {
      this.errorsControlActive = true;
      this.errors = [
        this.t('The values in New Password and Repeat Password fields should match')
      ];
    }

    if(this.errors.length){
      this.errors.unshift(this.t('Validation failed'));
      this.errorsControlActive = true;
    }

    if(this.state['oldPassword:error']
      || this.state['password:error']
      || this.state['confirmPassword:error']
      || this.errors.length
    ) return this.state.loading = false;

    return this.userApi.putUser(this.form).then(() => {
      this.close();
      this.form = {};
      this.bus.emit('toast-success', this.t('Password has been successfully changed'));
    }).catch((e:any) => {
      this.$store.commit('loading', false);
      
      const data = e.response.data;
      this.errors = this.translateErrors(this.parseErrors(data.errors, ErrorParseMethodEnum.numerate), data.message, {});
      this.errorsControlActive = true;

      return Promise.reject(e);
    });
  }
}
